import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { INoticeBoard } from '../../interfaces';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateNotice } = useService();

	const createNotice = (createdData: { noticeData: INoticeBoard }) => {
		setShowLoader(true);
		const { noticeData } = createdData;

		requestCreateNotice(app.appName, { ...noticeData, enabled: false }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the notice', { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Notice created');
				setShowLoader(false);
				history.push({
					pathname: '/dashboard/notices/list'
				});
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		createNotice(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
